module.exports = __webpack_public_path__ + "static/img/new_qlc.88902b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_qlc.png
// module id = K34+
// module chunks = 101